import React from 'react';
import { fetchUserMvp, getActiveCode, getBuddyYouthCommunity, mvpSignUp } from 'redux/actions/user.action';
import { connect } from 'react-redux';
import './signin.scss';
import { Redirect } from 'react-router-dom';
import { I18n } from '../../helpers/i18n';
import arrowBackIcon from 'static/images/mvp/black-arrow-left.png';
import { toast } from 'react-toastify';
import {
  FormSection,
  SectionBody,
  SectionFooter,
} from 'aws-amplify-react/lib/Amplify-UI/Amplify-UI-Components-React';
import SignUpUnifiedForm from './SignUpUnifiedForm';
import warning from '../../static/images/mvp/warning.png';

const SENIOR = 'explorer';
const BUDDY = 'guide';
const BOTH = 'both';
const HEALTH_STATUS_DEFAULT = 'normal';
const BUDDY_YOUTH_COMMUNITY = 'N/A';
const INPUTS = {
  ['name']: '',
  ['password']: '',
  ['rePassword']: '',
  ['email']: '',
  ['healthNote']: '',
  ['relativeName']: '',
  ['relativeEmail']: '',
  ['giftCode']: '',
};
class SignUp extends React.Component {
  constructor(props) {
    super(props);
    this.inputs = { ...INPUTS };
    this.intervalId = null;
    this.state = {
      time: 120,
      type: '',
      errorEmail: '',
      errorOtp: '',
      errorName: '',
      errorPassword: '',
      errorRePassword: '',
      errorNote: '',
      errorRelativeName: '',
      errorGiftCode: '',
      errorRelativeEmail: '',
      errorYouthCommunity: '',
      step: 1,
      nextStep: 1,
      redirectToReferrer: false,
      redirectToHome: false,
      getOtpSuccess: true,
      isLoading: false,
      listBuddyYouthCommunity: [],
      healthStatusList: [
        {
          value: HEALTH_STATUS_DEFAULT,
          label: I18n.t('health_normal'),
        },
        {
          value: 'needSupport',
          label: I18n.t('health_need_support'),
        },
      ],
      youthCommunity: '',
      healthStatus: HEALTH_STATUS_DEFAULT,
      isOtpComplete: false,
    };

    this.nextStep = this.nextStep.bind(this);
    this.handleBack = this.handleBack.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.getOtpVerify = this.getOtpVerify.bind(this);
    this.signUp = this.signUp.bind(this);
    this.reGetOtpVerify = this.reGetOtpVerify.bind(this);
  }

  async componentDidMount() {
    const { getBuddyYouthCommunity } = this.props;
    getBuddyYouthCommunity({ forSignup: true }).then((rs) => {
      this.setState({ listBuddyYouthCommunity: rs });
    });
  }

  componentWillUnmount() {
    clearInterval(this.intervalId); // Dọn dẹp interval khi component bị unmount
  }

  startCountdown = () => {
    this.intervalId = setInterval(() => {
      this.setState((prevState) => {
        if (prevState.time <= 0) {
          clearInterval(this.intervalId);
          return { time: 0 };
        }
        return { time: prevState.time - 1 };
      });
    }, 1000);
  };

  validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      );
  };

  checkOtpComplete = () => {
    const inputs = document.querySelectorAll('.verification-container input');
    let otpLength = 0;
    inputs.forEach((input) => {
      if (input.value.trim()) {
        otpLength++;
      }
    });
    const isComplete = otpLength === 5;
    this.setState({ isOtpComplete: isComplete });
  };

  handleKeyDown = (event) => {
    this.moveFocus('prev', event);
    // Check OTP completion after a short delay to allow the value to be cleared
    setTimeout(() => {
      this.checkOtpComplete();
    }, 0);
  };

  handleInput = (event) => {
    if (!/^\d$/.test(event.target.value)) {
      event.target.value = '';
      this.checkOtpComplete();
      return;
    }
    this.moveFocus('next', event);
    event.target.style.animation = 'none';
    event.target.offsetHeight; /* trigger reflow */
    event.target.style.animation = null;
    this.checkOtpComplete();
  };

  moveFocus(direction, event = null) {
    const inputs = document.querySelectorAll('.verification-container input');
    const index = Array.prototype.indexOf.call(inputs, event.target);

    if (direction === 'next' && event.target.value.length === 1) {
      if (index < inputs.length - 1) {
        inputs[index + 1].focus();
      }
    }

    if (direction === 'prev' && event.key === 'Backspace' && !event.target.value) {
      if (index > 0) {
        inputs[index - 1].focus();
      }
    }
  }

  handleSelectHealthStatus = (data) => {
    this.setState({ healthStatus: data });
  };

  handleSelectCommunity = (data) => {
    this.setState({ youthCommunity: data });
  };

  clearError() {
    this.setState({ errorEmail: '' });
    this.setState({ errorPassword: '' });
    this.setState({ errorRePassword: '' });
    this.setState({ errorNote: '' });
    this.setState({ errorRelativeName: '' });
    this.setState({ errorGiftCode: '' });
    this.setState({ errorRelativeEmail: '' });
    this.setState({ errorName: '' });
    this.setState({ errorOtp: '' });
    this.setState({ errorYouthCommunity: '' });
    this.setState({ time: 120 });
  }

  clearAllData() {
    this.clearError();
    this.setState({ youthCommunity: '' });
    this.setState({ healthStatus: HEALTH_STATUS_DEFAULT });
    this.inputs = { ...INPUTS };
  }

  verifyInput = () => {
    const { email, name, password, rePassword } = this.inputs;
    let verify = true;
    if (!email) {
      verify = false;
      this.setState({ errorEmail: I18n.t('text_field_required_error') });
    }
    if (email && !this.validateEmail(email)) {
      verify = false;
      this.setState({ errorEmail: I18n.t('email_invalid') });
    }
    if (!name) {
      verify = false;
      this.setState({ errorName: I18n.t('text_field_required_error') });
    }
    if (!password) {
      verify = false;
      this.setState({ errorPassword: I18n.t('text_field_required_error') });
    }
    if (!rePassword) {
      verify = false;
      this.setState({ errorRePassword: I18n.t('text_field_required_error') });
    }
    return verify;
  };

  verifySenior = () => {
    // Skip validation for relativeName and relativeEmail as they are not required in UI
    let verify = this.verifyInput();
    
    // Youth community is NOT required for explorer type
    // Only validate gift code if provided
    if (this.inputs.giftCode && this.inputs.giftCode.trim() === '') {
      verify = false;
      this.setState({ errorGiftCode: I18n.t('text_field_required_error') });
    }
    
    // Optional: Set default values for relativeName and relativeEmail if needed
    if (!this.inputs.relativeName) {
      this.inputs.relativeName = '';
    }
    if (!this.inputs.relativeEmail) {
      this.inputs.relativeEmail = '';
    }
    
    if (verify) {
      this.clearError();
    }
    return verify;
  };

  verifyBuddy = () => {
    let verify = this.verifyInput();
    
    // Validate youth community for guide type
    if (!this.state.youthCommunity || this.state.youthCommunity === '') {
      verify = false;
      this.setState({ errorYouthCommunity: I18n.t('text_field_required_error') });
    }
    
    // Gift code is optional for guide type - no validation needed
    
    if (verify) {
      this.clearError();
    }
    return verify;
  };

  verifyBoth = () => {
    let verify = this.verifyInput();
    
    // Validate youth community for both type
    if (!this.state.youthCommunity || this.state.youthCommunity === '') {
      verify = false;
      this.setState({ errorYouthCommunity: I18n.t('text_field_required_error') });
    }
    
    // Gift code is optional for both type - no validation needed
    
    // Optional: Set default values for relativeName and relativeEmail if needed
    if (!this.inputs.relativeName) {
      this.inputs.relativeName = '';
    }
    if (!this.inputs.relativeEmail) {
      this.inputs.relativeEmail = '';
    }
    
    if (verify) {
      this.clearError();
    }
    return verify;
  };

  async nextStep() {
    let { type, step, nextStep } = this.state;
    
    // Disable button if already loading
    if (this.state.isLoading) {
      // console.log('❌ [DEBUG] Already loading, returning');
      return;
    }
    
    if (!type) {
      toast.error(I18n.t('please_select_account_type'), {
        position: 'top-center',
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: false,
        closeButton: false,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
        className: 'toast-error-container toast-error-container-after',
        theme: 'colored',
      });
      return;
    }
    
    // Set loading state when moving from step 2 to step 3
    if (step === 2) {
      this.setState({ isLoading: true });
    }
    
    nextStep += 1;
    const funcFactory = {
      [BUDDY]: this.verifyBuddy,
      [SENIOR]: this.verifySenior,
      [BOTH]: this.verifyBoth,
    };
    let verify = true;
    if (step === 2 && nextStep > step) {
      verify = funcFactory[type] ? funcFactory[type]() : true;
    }
    if (!verify) {
      this.setState({ isLoading: false });
      return;
    }
    if (nextStep === 3) {
      await this.getOtpVerify();
      
      // Add delay for dev environment
      if (process.env.NODE_ENV === 'development') {
        await new Promise(resolve => setTimeout(resolve, 3000));
      }
    }
    if (!this.state.getOtpSuccess) {
      this.setState({ isLoading: false });
      return;
    }
    // Reset OTP completion state when moving to step 3
    const stateUpdate = { step: step + 1, nextStep: nextStep, isLoading: false, type: type };
    if (nextStep === 3) {
      stateUpdate.isOtpComplete = false;
    }
    this.setState(stateUpdate);
  }

  async signUp() {
    // console.log('🔍 [DEBUG] signUp called');
    const inputs = document.querySelectorAll('.verification-container input');
    // console.log('🔍 [DEBUG] Found OTP inputs:', inputs.length);
    this.setState({ time: 0 });
    clearInterval(this.intervalId);
    let otp = '';
    
    // Collect OTP from user input
    let hasEmptyInput = false;
    inputs.forEach((input) => {
      if (!input.value.trim()) {
        hasEmptyInput = true;
        return;
      }
      otp += input.value.trim();
    });
    
    // Validate OTP: check if all inputs are empty
    if (hasEmptyInput && otp === '') {
      // All inputs are empty - show required field error
      this.setState({ errorOtp: I18n.t('text_field_required_error') });
      return;
    } else if (hasEmptyInput) {
      // Some inputs are empty but user has partially entered OTP - show incorrect code error
      this.setState({ errorOtp: I18n.t('incorrect_verification_code') });
      return;
    }
    
    // Validate OTP length
    if (otp.length !== 5) {
      this.setState({ errorOtp: I18n.t('incorrect_verification_code') });
      return;
    }
    
    // OTP format is valid, clear previous errors and proceed to verify with API
    this.setState({ errorOtp: '', isLoading: true });
    // console.log('🔍 [DEBUG] OTP collected:', otp);

    const { mvpSignUp, fetchUserMvp } = this.props;
    const { email, password, name, healthNote, relativeName, relativeEmail, giftCode } = this.inputs;
    const params = {
      email: email,
      type: this.state.type,
      password: password,
      active_code: otp,
      name: name,
    };

    if (this.state.type === SENIOR || this.state.type === BOTH) {
      params['giftCode'] = giftCode;
      params['healthStatus'] = this.state.healthStatus;
      params['healthNote'] = healthNote;
      params['infoFamily'] = {
        name: relativeName,
        phone: '',
        email: relativeEmail,
        relation: '',
      };
    }
    
    if (this.state.type === BUDDY || this.state.type === BOTH) {
      // Validate youth community is selected
      if (!this.state.youthCommunity || this.state.youthCommunity === '') {
        this.setState({ errorYouthCommunity: I18n.t('text_field_required_error') });
        return;
      }
      // Send index (1-based) if we can resolve from list, otherwise send value/name string (e.g. "CED Group 1") for API to resolve
      const youthCommunitySelected = this.state.youthCommunity;
      const listBuddy = this.state.listBuddyYouthCommunity;
      let youthCommunityParam = youthCommunitySelected;
      if (listBuddy && listBuddy.length > 0) {
        const foundIndex = listBuddy.findIndex(item => item.value === youthCommunitySelected || item.name === youthCommunitySelected || item.label === youthCommunitySelected);
        if (foundIndex !== -1 && foundIndex > 0) {
          youthCommunityParam = foundIndex;
        }
      }
      params['youthCommunity'] = youthCommunityParam;
    }
    return mvpSignUp(params)
      .then((result) => {
        if (result.status === 'OK') {
          // save to storage
          let dataUser = {
            type: result.user.type,
            mvpUserType: result.user.mvpUserType,
            name: result.user.name,
            _id: result.user._id,
            accessToken: result.accessToken,
          };
          localStorage.setItem('ced:user-info', JSON.stringify(dataUser));
          fetchUserMvp();
          toast.success(I18n.t('registered_successful'), {
            position: 'top-center',
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            closeButton: false,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
            className: 'toast-error-container toast-error-container-after',
            theme: 'colored',
          });
          this.setState({ redirectToHome: true });
        } else {
          // Show error message (could be OTP error or other validation errors)
          const errorMessage = result.message || I18n.t('incorrect_verification_code');
          this.setState({ errorOtp: errorMessage, isLoading: false });
        }
      })
      .catch((err) => {
        // Handle network errors or other exceptions
        const errorMessage = err.message || I18n.t('incorrect_verification_code');
        this.setState({ errorOtp: errorMessage, isLoading: false });
        return Promise.reject(err);
      });
  }

  async reGetOtpVerify() {
    const inputs = document.querySelectorAll('.verification-container input');
    inputs?.forEach((input) => {
      input.value = '';
    });
    this.setState({ isOtpComplete: false });
    await this.getOtpVerify();
  }

  async getOtpVerify() {
    // console.log('🔍 [DEBUG] getOtpVerify called');
    const { email, password, name, giftCode } = this.inputs;
    const { type, youthCommunity, listBuddyYouthCommunity } = this.state;
    // For guide/both: send 1-based index if we can resolve, otherwise send value/name string (e.g. "CED Group 1") for API to resolve
    let youthCommunityParam = null;
    if ((type === BUDDY || type === BOTH) && youthCommunity) {
      if (listBuddyYouthCommunity && listBuddyYouthCommunity.length > 0) {
        const foundIndex = listBuddyYouthCommunity.findIndex(item => item.value === youthCommunity || item.name === youthCommunity || item.label === youthCommunity);
        if (foundIndex !== -1 && foundIndex > 0) {
          youthCommunityParam = foundIndex;
        } else {
          // Send string so API can resolve by name/nameEn/value (e.g. "CED Group 1")
          youthCommunityParam = youthCommunity;
        }
      } else {
        youthCommunityParam = youthCommunity;
      }
    }
    this.setState({ getOtpSuccess: true });
    this.setState({ time: 120 });
    this.setState({ errorOtp: '' });
    this.setState({ errorGiftCode: '' });
    this.setState({ isOtpComplete: false });
    clearInterval(this.intervalId);
    this.startCountdown();
    await this.props.getActiveCode(email, password, type, name, giftCode, youthCommunityParam).then((res) => {
      if (res.status !== 'OK') {
        clearInterval(this.intervalId);
        this.setState({ getOtpSuccess: false });
        this.setState({ time: 0 });
        if (res.type === 'inline') {
          this.setState({ errorGiftCode: res.message });
          return
        }
        toast.error(`${res.message}`, {
          position: 'top-center',
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: false,
          closeButton: false,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
          className: 'toast-error-container toast-error-container-after',
          theme: 'colored',
        });
      } else {
        // console.log('✅ [DEBUG] getOtpVerify success');
      }
    });
  }

  handleBack() {
    let { step } = this.state;
    if (step !== 1) {
      step -= 1;
      this.setState({ step: step });
      this.setState({ nextStep: step });
      if (step === 1) {
        this.clearAllData();
      }
      return;
    }
    this.setState({ redirectToReferrer: true });
  }

  handleChooseType = (value) => {
    // console.log('🔍 [DEBUG] handleChooseType called with:', value);
    const currentType = this.state.type;
    let newType = '';
    
    if (value === SENIOR) {
      // If clicking Explorer
      if (currentType === SENIOR) {
        // If already selected, deselect it
        newType = '';
      } else if (currentType === BUDDY) {
        // If Guide is selected, add Explorer (both)
        newType = BOTH;
      } else if (currentType === BOTH) {
        // If both selected, remove Explorer (keep Guide)
        newType = BUDDY;
      } else {
        // If nothing selected, select Explorer
        newType = SENIOR;
      }
    } else if (value === BUDDY) {
      // If clicking Guide
      if (currentType === BUDDY) {
        // If already selected, deselect it
        newType = '';
      } else if (currentType === SENIOR) {
        // If Explorer is selected, add Guide (both)
        newType = BOTH;
      } else if (currentType === BOTH) {
        // If both selected, remove Guide (keep Explorer)
        newType = SENIOR;
      } else {
        // If nothing selected, select Guide
        newType = BUDDY;
      }
    }
    
    this.setState({ type: newType });
  };

  handleInputChange(evt) {
    this.inputs = this.inputs || { ...INPUTS };
    const { name, value, type, checked } = evt.target;
    const check_type = ['radio', 'checkbox'].includes(type);
    this.inputs[name] = check_type ? checked : value;
    this.inputs['checkedValue'] = check_type ? value : null;
    const password = this.inputs.password;
    const rePassword = this.inputs.rePassword;
    if (password && rePassword && password !== rePassword) {
      this.setState({ errorRePassword: I18n.t('repeat_password_match') });
    } else {
      this.setState({ errorRePassword: '' });
    }
  }

  getTitleByTitle = (title) => {
    if (title === 'CREATE') {
      return I18n.t('register_both');
    }
    return I18n.t('account_type_selection_title');
  }

  render() {
    const { redirectToReferrer, redirectToHome, step, type, time, errorOtp } = this.state;
    const isStepChooseType = step === 1;
    const isStepPersonal = step === 2;
    const isStepSignUpVerify = step === 3;
    const isSenior = isStepPersonal && type === SENIOR;
    const isBuddy = isStepPersonal && type === BUDDY;
    let typeTitle = this.getTitleByTitle(type) || I18n.t('account_type_selection_title');
    let buttonTitle = isStepChooseType ? I18n.t('continue_text') : I18n.t('register');
    if (isStepSignUpVerify) {
      typeTitle = I18n.t('verification_code');
      buttonTitle = I18n.t('verification_account');
    }
    // When on step 2 (personal info step), set typeTitle to register_both
    if (isStepPersonal) {
      typeTitle = I18n.t('register_both');
    }
    
    // console.log('🔍 [DEBUG] Render state:', { 
    //   step, type, isStepChooseType, isStepPersonal, isStepSignUpVerify, 
    //   buttonTitle, typeTitle, inputs: this.inputs 
    // });

    if (redirectToReferrer === true) {
      return <Redirect to="/login" />;
    }

    if (redirectToHome === true) {
      return <Redirect to="/" />;
    }

    return (
      <div id="site_wrapper">
        {this.props.header}
        <div id="mvp-sign-up-modal">
          <FormSection style={{ width: '438px' }}>
            <div className="d-flex align-items-center mb-4">
              <img className="cursor-pointer" src={arrowBackIcon} alt="Arrow Back" onClick={this.handleBack} />
              <span className="title">{typeTitle}</span>
            </div>
            {isStepChooseType && (
              <SectionBody>
                <div
                  className={`card-sign-up senior mb-4 cursor-pointer ${this.state.type === SENIOR || this.state.type === BOTH ? 'checked' : ''}`}
                  onClick={() => this.handleChooseType(SENIOR)}
                >
                  <div className="d-flex align-items-center justify-content-between mb-2">
                    <h5 className="mb-0">{I18n.t('account_type_selection_senior')}</h5>
                    <label>
                      <input type="checkbox" checked={this.state.type === SENIOR || this.state.type === BOTH} />
                      <div className="outer-circle">
                        <div className="inner-circle"></div>
                      </div>
                    </label>
                  </div>
                  <span className="text-muted">
                    {I18n.t('account_type_selection_senior_des')}
                  </span>
                </div>
                <div
                  className={`card-sign-up buddy mb-4 cursor-pointer ${this.state.type === BUDDY || this.state.type === BOTH ? 'checked' : ''}`}
                  onClick={() => this.handleChooseType(BUDDY)}
                >
                  <div className="d-flex align-items-center justify-content-between mb-2">
                    <h5 className="mb-0">{I18n.t('account_type_selection_senior_buddy')}</h5>
                    <label className="circle">
                      <input type="checkbox" checked={this.state.type === BUDDY || this.state.type === BOTH} />
                      <div className="outer-circle">
                        <div className="inner-circle"></div>
                      </div>
                    </label>
                  </div>
                  <span className="text-muted">
                    {I18n.t('account_type_selection_senior_buddy_des')}
                  </span>
                </div>
              </SectionBody>
            )}
            {isStepPersonal && (
              <>
                <SignUpUnifiedForm
                  {...this.state}
                  {...this.inputs}
                  onSelectCommunity={this.handleSelectCommunity}
                  onSelectHealthStatus={this.handleSelectHealthStatus}
                  onInputChange={this.handleInputChange}
                />
              </>
            )}
            {isStepSignUpVerify && (
              <div className="d-flex flex-column">
                <span className="text-muted">{I18n.t('sent_to_email')}</span>
                <p style={{ textDecoration: 'underline' }}>{this.inputs.email}</p>
                <div className="verification-container">
                  <input type="text" maxLength="1" onInput={this.handleInput} onKeyDown={this.handleKeyDown} />
                  <input type="text" maxLength="1" onInput={this.handleInput} onKeyDown={this.handleKeyDown} />
                  <input type="text" maxLength="1" onInput={this.handleInput} onKeyDown={this.handleKeyDown} />
                  <input type="text" maxLength="1" onInput={this.handleInput} onKeyDown={this.handleKeyDown} />
                  <input type="text" maxLength="1" onInput={this.handleInput} onKeyDown={this.handleKeyDown} />
                </div>
                {errorOtp && (
                  <span className="error-message mt-1">
                    <img src={warning} style={{ marginTop: '-5px', marginRight: '4px' }} />
                    {errorOtp}
                  </span>
                )}
                {time > 0 && (
                  <div className="d-flex gap-2 mt-2">
                    <span className="text-muted mr-2">{I18n.t('resend_verification_code_after')} </span>
                    <p>{time}s</p>
                  </div>
                )}
                {time === 0 && (
                  <div className="d-flex gap-2 mt-2">
                    <span
                      onClick={this.reGetOtpVerify}
                      style={{ color: '#0564F1', textDecoration: 'underline', cursor: 'pointer' }}
                    >
                      {I18n.t('resend_verification_code')}
                    </span>
                  </div>
                )}
              </div>
            )}
            <SectionFooter>
              {!isStepSignUpVerify && (
                <button 
                  onClick={() => {
                    // console.log('🔍 [DEBUG] Continue/Register button clicked (step:', this.state.step, ')');
                    if(this.state.step === 1) {
                      this.handleChooseType('CREATE');
                    }
                    this.nextStep();
                  }} 
                  type="button" 
                  className="btn btn-warning next-step"
                  disabled={this.state.isLoading}
                  style={{ 
                    opacity: this.state.isLoading ? 0.6 : 1,
                    cursor: this.state.isLoading ? 'not-allowed' : 'pointer'
                  }}
                >
                  {this.state.isLoading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                      {I18n.t('processing')}
                    </>
                  ) : (
                    I18n.t(`${buttonTitle}`)
                  )}
                </button>
              )}
              {isStepSignUpVerify && (
                <button
                  style={{ 
                    width: '100%', 
                    marginTop: '50px',
                    opacity: (this.state.isOtpComplete && !this.state.isLoading) ? 1 : 0.6,
                    cursor: (this.state.isOtpComplete && !this.state.isLoading) ? 'pointer' : 'not-allowed'
                  }}
                  onClick={() => {
                    // console.log('🔍 [DEBUG] SignUp button clicked (step:', this.state.step, ')');
                    if (this.state.isOtpComplete && !this.state.isLoading) {
                      this.signUp();
                    }
                  }}
                  type="button"
                  className="btn btn-warning next-step"
                  disabled={!this.state.isOtpComplete || this.state.isLoading}
                >
                  {this.state.isLoading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                      {I18n.t('processing')}
                    </>
                  ) : (
                    I18n.t(`${buttonTitle}`)
                  )}
                </button>
              )}
            </SectionFooter>
          </FormSection>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ user }) => ({
  userInfo: user,
});

const mapDispatchToProps = { getBuddyYouthCommunity, getActiveCode, fetchUserMvp, mvpSignUp };

export default connect(mapStateToProps, mapDispatchToProps)(SignUp);
